import React from 'react';
export const CTASection = () => {
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    // Form would submit to backend in production
    const formData = new FormData(e.currentTarget);
    console.log('Form submitted:', Object.fromEntries(formData));
    alert('Thank you! We will contact you shortly to schedule your demo.');
  };
  return <section id="contact" className="py-16 md:py-24 bg-blue-600" data-id="element-21">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-22">
        <div className="max-w-4xl mx-auto text-center" data-id="element-23">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-24">
            Ready to transform your sales hiring?
          </h2>
          <p className="text-xl text-blue-100 mb-8" data-id="element-25">
            Join hundreds of companies using ApplicantPass to build
            high-performing sales teams
          </p>
          <div className="bg-white p-8 rounded-lg shadow-lg" data-id="element-26">
            <h3 className="text-2xl font-semibold text-gray-900 mb-6" data-id="element-27">
              Request a Demo
            </h3>
            <form className="space-y-4" onSubmit={handleSubmit} action="/api/demo-request" method="POST" data-id="element-28">
              <div className="grid md:grid-cols-2 gap-4" data-id="element-29">
                <div data-id="element-30">
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-31">
                    Full Name
                  </label>
                  <input type="text" id="name" name="name" required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500" placeholder="John Smith" data-id="element-32" />
                </div>
                <div data-id="element-33">
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-34">
                    Work Email
                  </label>
                  <input type="email" id="email" name="email" required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500" placeholder="john@company.com" data-id="element-35" />
                </div>
              </div>
              <div className="grid md:grid-cols-2 gap-4" data-id="element-36">
                <div data-id="element-37">
                  <label htmlFor="company" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-38">
                    Company Name
                  </label>
                  <input type="text" id="company" name="company" required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500" placeholder="Acme Inc" data-id="element-39" />
                </div>
                <div data-id="element-40">
                  <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-41">
                    Phone Number
                  </label>
                  <input type="tel" id="phone" name="phone" required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500" placeholder="(123) 456-7890" data-id="element-42" />
                </div>
              </div>
              <div data-id="element-43">
                <label htmlFor="hiring_volume" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-44">
                  How many sales roles do you hire for annually?
                </label>
                <select id="hiring_volume" name="hiring_volume" required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500" data-id="element-45">
                  <option value="" data-id="element-46">Select an option</option>
                  <option value="1-5" data-id="element-47">1-5 roles</option>
                  <option value="6-20" data-id="element-48">6-20 roles</option>
                  <option value="21-50" data-id="element-49">21-50 roles</option>
                  <option value="50+" data-id="element-50">50+ roles</option>
                </select>
              </div>
              <button type="submit" className="w-full py-3 px-4 bg-blue-600 text-white font-medium rounded-md hover:bg-blue-700 transition-colors" data-id="element-51">
                Schedule My Demo
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>;
};